import { OpportunityStatus } from '@ndvr/customer-api';

import { Badge } from '@/components/ui/badge';

interface OpportunityStatusBadgeProps {
    status: OpportunityStatus;
}

const statusConfig: Record<
    OpportunityStatus,
    {
        label: string;
        variant: 'default' | 'secondary' | 'destructive' | 'outline' | 'success' | 'mint';
    }
> = {
    [OpportunityStatus.IDENTIFIED]: {
        label: 'Identified',
        variant: 'secondary',
    },
    [OpportunityStatus.INFO_GATHERING]: {
        label: 'Info Gathering',
        variant: 'outline',
    },
    [OpportunityStatus.RECOMMENDATION]: {
        label: 'Recommendation',
        variant: 'default',
    },
    [OpportunityStatus.DECISION]: {
        label: 'Decision',
        variant: 'mint',
    },
    [OpportunityStatus.ONBOARDING]: {
        label: 'Onboarding',
        variant: 'default',
    },
    [OpportunityStatus.CLOSED_LOST]: {
        label: 'Closed Lost',
        variant: 'destructive',
    },
    [OpportunityStatus.CLOSED_WON]: {
        label: 'Closed Won',
        variant: 'success',
    },
};

export function OpportunityStatusBadge({ status }: OpportunityStatusBadgeProps) {
    const config = statusConfig[status];
    return <Badge variant={config.variant}>{config.label}</Badge>;
}
